import type {VirtualKeyboardOptions} from './types';

export const DEFAULT_VIRTUAL_KEYBOARD_OPTIONS: VirtualKeyboardOptions = {
  preventFocus: true,
  clearOnBlur: false,
  className: 'w-full h-full',
  autoShowOnFocus: true,
  defaultVisible: false,
  autoHideOnBlur: true,
};
